export default __webpack_public_path__ + "static/media/Ies_Panel2_ENG.f4718738.jpg";